import React, { Suspense } from 'react';

const PrivacyPolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.PrivacyPolicy })));
const TermsOfService = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.TermsOfService })));
const SecurityPage = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.SecurityPage })));
const AboutPage = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.AboutPage })));
const ContactPage = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.ContactPage })));
const PurchaseTerms = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.PurchaseTerms })));
const CookiePolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.CookiePolicy })));
const AcceptableUsePolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.AcceptableUsePolicy })));
const DataProcessingAgreement = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.DataProcessingAgreement })));
const Disclaimer = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.Disclaimer })));
const ResponsibleDisclosure = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.ResponsibleDisclosure })));
const ServiceLevelAgreement = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.ServiceLevelAgreement })));
const EndUserLicenceAgreement = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.EndUserLicenceAgreement })));
const SovereignDataResidencyPolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.SovereignDataResidencyPolicy })));
const WhistleblowerPolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.WhistleblowerPolicy })));
const IncidentResponsePolicy = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.IncidentResponsePolicy })));
const AccessibilityStatement = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.AccessibilityStatement })));
const IntellectualPropertyNotice = React.lazy(() => import('../LegalPages').then((m) => ({ default: m.IntellectualPropertyNotice })));

interface LegalRouterProps {
  view: string;
  onBack: () => void;
}

const Spinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-[#060a14]">
    <div className="relative w-12 h-12">
      <div className="absolute inset-0 border-2 border-cyan-500/20 rounded-full" />
      <div className="absolute inset-0 border-2 border-transparent border-t-cyan-400 rounded-full animate-spin" />
    </div>
  </div>
);

export const LegalRouter: React.FC<LegalRouterProps> = ({ view, onBack }) => {
  return (
    <Suspense fallback={<Spinner />}>
      {view === 'privacy' && <PrivacyPolicy onBack={onBack} />}
      {view === 'terms' && <TermsOfService onBack={onBack} />}
      {view === 'security' && <SecurityPage onBack={onBack} />}
      {view === 'about' && <AboutPage onBack={onBack} />}
      {view === 'contact' && <ContactPage onBack={onBack} />}
      {view === 'purchase-terms' && <PurchaseTerms onBack={onBack} />}
      {view === 'cookies' && <CookiePolicy onBack={onBack} />}
      {view === 'acceptable-use' && <AcceptableUsePolicy onBack={onBack} />}
      {view === 'dpa' && <DataProcessingAgreement onBack={onBack} />}
      {view === 'disclaimer' && <Disclaimer onBack={onBack} />}
      {view === 'responsible-disclosure' && <ResponsibleDisclosure onBack={onBack} />}
      {view === 'sla' && <ServiceLevelAgreement onBack={onBack} />}
      {view === 'eula' && <EndUserLicenceAgreement onBack={onBack} />}
      {view === 'data-residency' && <SovereignDataResidencyPolicy onBack={onBack} />}
      {view === 'whistleblower' && <WhistleblowerPolicy onBack={onBack} />}
      {view === 'incident-response' && <IncidentResponsePolicy onBack={onBack} />}
      {view === 'accessibility' && <AccessibilityStatement onBack={onBack} />}
      {view === 'ip-notice' && <IntellectualPropertyNotice onBack={onBack} />}
    </Suspense>
  );
};
